import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

// set master-header's top property dynamically based on nav height
const topNav        = document.querySelector('.navbar.navbar-expand-lg.navbar-slate');
const masterHeader  = document.querySelector('header.master-header');
const pageHeader    = document.querySelector('header.page-header');

if (topNav) {
  const topNavHeight = `${topNav.getBoundingClientRect().height}px`;
  if (masterHeader) masterHeader.style.top = topNavHeight;
  if (pageHeader) pageHeader.style.top = topNavHeight;
}

export { application }
